
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { loadPaginatedECPurchases } from "@/api/onlineshop";

export default defineComponent({
  name: "shoppurchases",
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      list: [],
      loading: true,
    };
  },
  mounted() {
    this.loadPaginatedECPurchases();
  },
  methods: {
    async loadPaginatedECPurchases() {
      this.loading = true;
      const response = await loadPaginatedECPurchases(1);
      this.list = response.data.pageList;
      this.loading = false;
    },
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Online Shop");
    });
  },
});
